module.exports = __webpack_public_path__ + "static/018-4dbb2cf76fc93d1fc7e26d2152a28e1a.png";